<template lang="pug">
collapse-component.conteudo(title='Filtrar processos')
    .linha
        .coluna-3
            text-input-component(v-model='filtro.car', label='Número de registro no CAR')
        .coluna-3
            text-input-component(v-model='filtro.nomeImovel', label='Nome do imóvel')
    .linha(style="align-items: flex-start")
        .coluna-3
            text-input-component(v-model='filtro.cpfCnpjProprietario', label='CPF/CNPJ')
        .coluna-2
            date-picker-component(v-model='filtro.dataEnvioDe', :label='"Data inicial" + (isUsuarioSemil() ? " assinatura" : "")')
        .coluna-2
            date-picker-component(v-model='filtro.dataEnvioAte', :label='"Data final" + (isUsuarioSemil() ? " assinatura" : "")')
        .coluna-3
            select-filter-component(
                ref='selectCondicao'
                :list='condicoes',
                label='nome',
                key='nome',
                fieldLabel='Condição',
                :clearable='false'
                @change='selecionarCondicao'
            )
    .linha(style="align-items: flex-start")
        .coluna-2
            text-input-component(:disabled='true', v-model='filtro.uf', label='UF')
        .coluna-2
            select-filter-component(
                ref='selectMunicipio'
                :list='municipios'
                label='nome'
                fieldLabel='Município:'
                placeholder='Selecione'
                :filterable='true'
                @change='selecionarMunicipio'
            )
        .coluna-2
            select-filter-component(
                v-if="mostrarFaseProcesso"
                ref='selectCondicaoInscricao'
                :list='condicoesInscricao'
                key='id',
                label='label'
                fieldLabel='Fase do Processo:'
                placeholder='Selecione'
                :filterable='true'
                @change='selecionarCondicaoInscricao'
            )
    .linha.justify-end
        .coluna-1
            button-component(
                label='Limpar',
                icon='mdi-trash-can',
                background-color='#ddd',
                color='#666',
                @click.native='limpar'
            )
        .coluna-1
            button-component(label='Pesquisar', icon='mdi-magnify', @click.native='pesquisar')
</template>

<script>
import { CondicaoEnum, CondicaoInscricaoEnum, ListaCondicoes } from '@/enums/processo.enum.js';
import { Perfil } from '@/utils/constants.utils.js';

export default {
    name: 'FiltroComponent',
    props: {
        municipios: {
            type: Array,
            required: true,
        },
        mostrarFaseProcesso: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            filtro: {
                uf: 'SP',
                pagina: 1,
                quantidadePagina: 10,
            },
            CondicaoEnum,
            condicoes: [],
            CondicaoInscricaoEnum,
            condicoesInscricao: [],
            usuario: this.$eu(),
        };
    },
    watch: {
        '$route.meta.titulo'() {
            this.filtrarCondicoes();
            this.filtrarCondicoesInscricao();
        }
    },

    mounted() {
        this.filtrarCondicoes();
        this.filtrarCondicoesInscricao();
    },

    methods: {
        isUsuarioSemil() {
            return this.usuario.perfil === Perfil.SEMIL;
        },
        isPageValidacaoProposta() {
            return this.$route.meta.titulo === 'Validação da Proposta';
        },
        filtrarCondicoes() {
            this.limpar();
            let codigoPagina = this.$route.meta.codigo;                    
            if (this.usuario.perfil === Perfil.GERENTE_OPERACIONAL && codigoPagina === 'CONSULTAR_PROCESSOS'){
                codigoPagina = codigoPagina  + '_GO';
            }
            if (this.isUsuarioSemil() && codigoPagina === 'CONSULTAR_PROCESSOS'){
                codigoPagina = codigoPagina  + '_SEMIL';
                this.$refs.selectCondicao.itemSelecionado = CondicaoEnum.TERMO_COMPROMISSO_ASSINADO.nome;
            }
            this.condicoes = ListaCondicoes[codigoPagina];
            if (this.isPageValidacaoProposta()) {
                this.$refs.selectCondicao.itemSelecionado = CondicaoEnum.AGUARDANDO_VALIDACAO_ANALISE.nome;
            }
        },
        filtrarCondicoesInscricao(){
            this.condicoesInscricao = Object.values(CondicaoInscricaoEnum);
        },
        limpar() {
            this.filtro = {
                uf: 'SP',
                pagina: 1,
                quantidadePagina: 10,
            };
            this.$refs.selectCondicao.itemSelecionado = '';
            this.$refs.selectMunicipio.itemSelecionado = '';
            if (this.mostrarFaseProcesso && this.$refs.selectCondicaoInscricao) {
                this.$refs.selectCondicaoInscricao.itemSelecionado = '';
            }

            if (this.isPageValidacaoProposta()) {
                this.$refs.selectCondicao.itemSelecionado = CondicaoEnum.AGUARDANDO_VALIDACAO_ANALISE.nome;
            }
            if (this.isUsuarioSemil()){
                this.$refs.selectCondicao.itemSelecionado = CondicaoEnum.TERMO_COMPROMISSO_ASSINADO.nome;
            }
            this.$emit('filtro:limpar', this.filtro);
        },
        pesquisar() {
            this.$emit('filtro:pesquisar', this.filtro);
        },
        selecionarCondicao(condicao) {
            this.filtro.condicao = condicao;
        },
        selecionarCondicaoInscricao(condicaoInscricao) {
            this.filtro.condicaoInscricao = condicaoInscricao;
        },
        selecionarMunicipio(municipio) {
            this.filtro.municipio = municipio;
        }
    },
};
</script>
